import axios from 'axios';
import { deleteData, getData, storeData } from './storage';
import baseURL from '../config/baseURL';
import { getAuthToken } from './auth';
import { Organization } from '../utils/types';

export const organizationSignUp = async (
  name: any,
  description: any,
  industry: any,
  website: any,
  email: any,
  phone: any,
  address: any,
) => {
  const organizationData = {
    name: name,
    description: description,
    industry: industry,
    website: website,
    email: email,
    phone: phone,
    address: address,
  };

  try {
    let token = await getAuthToken();
    let header_token = 'Bearer ' + token.data;
    console.log('header_token', header_token);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: header_token,
    };
    const endpoint = `${baseURL}/core/organizations/`;
    const response = await axios.post(endpoint, organizationData, { headers });
    console.log('response from org sign up', response);
    if (response.status === 201) {
      console.log(
        'Sign Up successful! - Sign up request response Data - ',
        response.data,
      );
      return { success: true, data: response?.data };
    } else {
      console.error('Sign Up failed here:', response, response.data);
      return { success: false, data: response?.data };
    }
  } catch (error) {
    console.error('An unexpected error occurred:', error);
    // console.error('Error creating organization:', error?.response?.data || error.message);
    return { success: false, data: error };
  }
};

export const deleteOrganization = async (id: any) => {
  let token = await getAuthToken();

  if (token) {
    let header_token = 'Bearer ' + token.data;
    const headers = {
      Authorization: header_token,
    };
    try {
      const endpoint = `${baseURL}/core/organizations/${id}/`;
      const response = await axios.delete(endpoint, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error(
          'Organization deletion failed here:',
          response,
          response.data,
        );
        return { success: false, data: response?.data };
      }
    } catch (error) {
      console.error('An unexpected error occurred:', error);
      return { success: false, data: error };
    }
  } else {
    return { success: false, data: 'error: Token does not exist' };
  }
};

export const organizationAccountInfo = async (id: any) => {
  let token = await getAuthToken();

  if (token) {
    let header_token = 'Bearer ' + token.data;
    const headers = {
      Authorization: header_token,
    };
    try {
      const endpoint = `${baseURL}/core/organizations/${id}`;
      const response = await axios.get(endpoint, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error('Data retrieval failed here:', response, response.data);
        return { success: false, data: response?.data };
      }
    } catch (error) {
      console.error('An unexpected error occurred:', error);
      return { success: false, data: error };
    }
  } else {
    return { success: false, data: 'error: Token does not exist' };
  }
};

export const getCurentOrgDataFromStorage = async () => {
  try {
    const raw = await getData('org-data-selected');
    console.log('org-data-selected-raw', raw);

    if (!raw || raw === 'undefined' || raw === 'null') {
      return { success: false, data: 'error: Data does not exist' };
    }

    const parsed: Organization = JSON.parse(raw);

    return { success: true, data: parsed };
  } catch (err) {
    console.error('Failed to parse org data:', err);
    return {
      success: false,
      data: 'error: Failed to parse or retrieve organization data',
    };
  }
};

export const storeOrgDataToStorage = async (orgData: any) => {
  let data = await storeData('org-data-selected', JSON.stringify(orgData));

  if (data !== 0) {
    return { success: true, data: 1 };
  } else {
    return { success: false, data: 'error on storing data.' };
  }
};

export const removeOrgDataFromStorage = async () => {
  await deleteData('org-data-selected');
  return { success: true, data: 1 };
};

export const getOrganizations = async () => {
  let token = await getAuthToken();

  if (token) {
    let header_token = 'Bearer ' + token.data;
    const headers = {
      Authorization: header_token,
    };
    try {
      const endpoint = `${baseURL}/core/organizations/`;
      const response = await axios.get(endpoint, { headers });
      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response?.data };
      } else {
        console.error('Data retrieval failed here:', response, response.data);
        return { success: false, data: response?.data };
      }
    } catch (error) {
      console.error('An unexpected error occurred:', error);
      return { success: false, data: error };
    }
  } else {
    return { success: false, data: 'error: Token does not exist' };
  }
};
